import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "ToastHub" })
export default class ToastHub extends Vue {
    get toasts(): any {
        return this.$store.getters["appToastStore/toasts"]
    }

    public created() {
        (<any>this.$store).subscribeAction((action, state) => {
            // Add toast 
            if (action.type === "appToastStore/onAddToast") {
                this.addToast(action.payload);
            }
        });
    }

    public addToast(toast: any) {
        if (this.toasts.length <= 1) {
            toast.id = new Date().valueOf();

            this.toasts.push(toast);
            this.$store.commit("appToastStore/setToasts", this.toasts);

            setTimeout(() => {
                this.dismissToast(toast);
            }, 3 * 1000, toast)
        }
    }

    public dismissToast(toast: any) {
        for (var i = 0; i < this.toasts.length; i++) {
            if (this.toasts[i].id === toast.id) {
                this.toasts.splice(i, 1);
                this.$store.commit("appToastStore/setToasts", this.toasts);
                break;
            }
        }
    }
};